import { render, staticRenderFns } from "./ylpayExtra.vue?vue&type=template&id=b41a6bc6"
import script from "./ylpayExtra.vue?vue&type=script&lang=ts"
export * from "./ylpayExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports